import {
  searchRsvps as publicSearchRsvps,
  queryRsvps as publicQueryRsvps,
  typedQueryRsvps as publicTypedQueryRsvps,
  countRsvps as publicCountRsvps,
  getRsvp as publicGetRsvp,
  createRsvp as publicCreateRsvp,
  updateRsvp as publicUpdateRsvp,
  deleteRsvp as publicDeleteRsvp,
  bulkUpdateRsvps as publicBulkUpdateRsvps,
  bulkDeleteRsvpsByFilter as publicBulkDeleteRsvpsByFilter,
  checkInRsvpGuests as publicCheckInRsvpGuests,
  cancelRsvpGuestsCheckIn as publicCancelRsvpGuestsCheckIn,
  listRsvpSummary as publicListRsvpSummary,
  listCurrentRsvps as publicListCurrentRsvps,
} from './events-v2-rsvp-rsvp-v-2.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  QueryRsvpsOptions,
  RsvpQuery,
  RsvpsQueryBuilder,
  typedQueryRsvps as universalTypedQueryRsvps,
} from './events-v2-rsvp-rsvp-v-2.universal.js';
import { onRsvpCreated as publicOnRsvpCreated } from './events-v2-rsvp-rsvp-v-2.public.js';
import { onRsvpDeleted as publicOnRsvpDeleted } from './events-v2-rsvp-rsvp-v-2.public.js';
import { onRsvpUpdated as publicOnRsvpUpdated } from './events-v2-rsvp-rsvp-v-2.public.js';

function customQueryRsvps(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryRsvpsOptions) =>
      publicQueryRsvps(httpClient)(options),
    typedQueryFunction: (query: RsvpQuery, options?: QueryRsvpsOptions) =>
      publicTypedQueryRsvps(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: RsvpQuery,
    options?: QueryRsvpsOptions
  ): ReturnType<typeof universalTypedQueryRsvps>;
  function overloadedQuery(options?: QueryRsvpsOptions): RsvpsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: RsvpQuery | QueryRsvpsOptions,
    options?: QueryRsvpsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const searchRsvps: MaybeContext<
  BuildRESTFunction<typeof publicSearchRsvps> & typeof publicSearchRsvps
> = /*#__PURE__*/ createRESTModule(publicSearchRsvps);
export const countRsvps: MaybeContext<
  BuildRESTFunction<typeof publicCountRsvps> & typeof publicCountRsvps
> = /*#__PURE__*/ createRESTModule(publicCountRsvps);
export const getRsvp: MaybeContext<
  BuildRESTFunction<typeof publicGetRsvp> & typeof publicGetRsvp
> = /*#__PURE__*/ createRESTModule(publicGetRsvp);
export const createRsvp: MaybeContext<
  BuildRESTFunction<typeof publicCreateRsvp> & typeof publicCreateRsvp
> = /*#__PURE__*/ createRESTModule(publicCreateRsvp);
export const updateRsvp: MaybeContext<
  BuildRESTFunction<typeof publicUpdateRsvp> & typeof publicUpdateRsvp
> = /*#__PURE__*/ createRESTModule(publicUpdateRsvp);
export const deleteRsvp: MaybeContext<
  BuildRESTFunction<typeof publicDeleteRsvp> & typeof publicDeleteRsvp
> = /*#__PURE__*/ createRESTModule(publicDeleteRsvp);
export const bulkUpdateRsvps: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateRsvps> & typeof publicBulkUpdateRsvps
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateRsvps);
export const bulkDeleteRsvpsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteRsvpsByFilter> &
    typeof publicBulkDeleteRsvpsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteRsvpsByFilter);
export const checkInRsvpGuests: MaybeContext<
  BuildRESTFunction<typeof publicCheckInRsvpGuests> &
    typeof publicCheckInRsvpGuests
> = /*#__PURE__*/ createRESTModule(publicCheckInRsvpGuests);
export const cancelRsvpGuestsCheckIn: MaybeContext<
  BuildRESTFunction<typeof publicCancelRsvpGuestsCheckIn> &
    typeof publicCancelRsvpGuestsCheckIn
> = /*#__PURE__*/ createRESTModule(publicCancelRsvpGuestsCheckIn);
export const listRsvpSummary: MaybeContext<
  BuildRESTFunction<typeof publicListRsvpSummary> & typeof publicListRsvpSummary
> = /*#__PURE__*/ createRESTModule(publicListRsvpSummary);
export const listCurrentRsvps: MaybeContext<
  BuildRESTFunction<typeof publicListCurrentRsvps> &
    typeof publicListCurrentRsvps
> = /*#__PURE__*/ createRESTModule(publicListCurrentRsvps);
export const queryRsvps: MaybeContext<
  BuildRESTFunction<typeof customQueryRsvps> & typeof customQueryRsvps
> = /*#__PURE__*/ createRESTModule(customQueryRsvps);
/**
 * Triggered when an RSVP is created.
 */
export const onRsvpCreated: BuildEventDefinition<typeof publicOnRsvpCreated> &
  typeof publicOnRsvpCreated = createEventModule(publicOnRsvpCreated);
/**
 * Triggered when an RSVP is deleted.
 */
export const onRsvpDeleted: BuildEventDefinition<typeof publicOnRsvpDeleted> &
  typeof publicOnRsvpDeleted = createEventModule(publicOnRsvpDeleted);
/**
 * Triggered when an RSVP is updated.
 */
export const onRsvpUpdated: BuildEventDefinition<typeof publicOnRsvpUpdated> &
  typeof publicOnRsvpUpdated = createEventModule(publicOnRsvpUpdated);

export {
  SubdivisionType,
  RsvpStatus,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
  RequestedFields,
  LocationType,
  Status,
  EventStatus,
  EventType,
  RegistrationStatus,
  RsvpStatusOptions,
  TaxType,
  CheckoutType,
  VisitorType,
  InputControlType,
  ValueType,
  ConferenceType,
  State,
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  Origin,
  LayoutDataBackgroundType,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  Type,
  WebhookIdentityType,
} from './events-v2-rsvp-rsvp-v-2.universal.js';
export {
  Rsvp,
  FormResponse,
  InputValue,
  FormattedAddress,
  CommonAddress,
  CommonAddressStreetOneOf,
  CommonStreetAddress,
  CommonAddressLocation,
  CommonSubdivision,
  StandardDetails,
  GuestList,
  Guest,
  CheckInDetails,
  AdditionalGuestDetails,
  AdditionalGuest,
  OnlineConferencingLogin,
  FormSubmission,
  ExtendedFields,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  LimitedRsvpSpotsReleased,
  RsvpsBalanceUpdated,
  V2RsvpSummary,
  RsvpBalanceDelta,
  SearchRsvpsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Sorting,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  CursorPaging,
  SearchRsvpsResponse,
  CursorPagingMetadata,
  Cursors,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  SearchRsvpsWithOffsetRequest,
  Search,
  SearchPagingMethodOneOf,
  Paging,
  SearchRsvpsWithOffsetResponse,
  PagingMetadataV2,
  ListRsvpsRequest,
  LargeCursorPaging,
  ListRsvpsResponse,
  QueryRsvpsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  QueryRsvpsResponse,
  CountRsvpsRequest,
  CountRsvpsResponse,
  GetRsvpRequest,
  GetRsvpResponse,
  CreateRsvpRequest,
  ModificationOptions,
  CreateRsvpResponse,
  CalendarLinks,
  GuestLimitExceededData,
  UpdateRsvpRequest,
  UpdateRsvpResponse,
  DeleteRsvpRequest,
  DeleteRsvpResponse,
  BulkUpdateRsvpsRequest,
  MaskedRsvp,
  BulkUpdateRsvpsResponse,
  ItemMetadata,
  ApplicationError,
  BulkRsvpResult,
  BulkActionMetadata,
  BulkDeleteRsvpsByFilterRequest,
  BulkDeleteRsvpsByFilterResponse,
  CheckInRsvpGuestsRequest,
  CheckInRsvpGuestsResponse,
  CancelRsvpGuestsCheckInRequest,
  CancelRsvpGuestsCheckInResponse,
  ListRsvpSummaryRequest,
  ListRsvpSummaryResponse,
  ListCurrentRsvpsRequest,
  ListCurrentRsvpsResponse,
  EventCreated,
  Location,
  MapCoordinates,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  ScheduleConfig,
  Recurrences,
  Occurrence,
  Event,
  Scheduling,
  Registration,
  RsvpCollection,
  RsvpCollectionConfig,
  RsvpConfirmationMessages,
  RsvpConfirmationMessagesPositiveResponseConfirmation,
  RsvpConfirmationMessagesNegativeResponseConfirmation,
  Ticketing,
  TicketingConfig,
  TaxConfig,
  TicketsConfirmationMessages,
  Money,
  ExternalEvent,
  SiteUrl,
  Form,
  InputControl,
  Input,
  OptionSelection,
  OptionSelectionSelectedOptionOneOf,
  Label,
  FormMessages,
  RsvpFormMessages,
  PositiveResponseConfirmation,
  NegativeResponseConfirmation,
  Positive,
  Negative,
  CheckoutFormMessages,
  ResponseConfirmation,
  RegistrationClosedMessages,
  TicketsUnavailableMessages,
  Dashboard,
  RsvpSummary,
  TicketingSummary,
  GuestListConfig,
  Feed,
  OnlineConferencing,
  OnlineConferencingConfig,
  OnlineConferencingSession,
  SeoSettings,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  Agenda,
  Category,
  CategoryCounts,
  EventDisplaySettings,
  LabellingSettings,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  Banner,
  LayoutDataBackground,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  Badge,
  Empty,
  EventDeleted,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  RsvpCreatedEnvelope,
  RsvpDeletedEnvelope,
  RsvpUpdatedEnvelope,
  SearchRsvpsOptions,
  RsvpSearchSpec,
  QueryRsvpsOptions,
  RsvpsQueryResult,
  RsvpsQueryBuilder,
  RsvpQuerySpec,
  CountRsvpsOptions,
  GetRsvpOptions,
  CreateRsvpOptions,
  UpdateRsvp,
  UpdateRsvpOptions,
  BulkUpdateRsvpsOptions,
  BulkDeleteRsvpsByFilterOptions,
  CheckInRsvpGuestsOptions,
  CancelRsvpGuestsCheckInOptions,
  ListCurrentRsvpsOptions,
} from './events-v2-rsvp-rsvp-v-2.universal.js';
export { utils } from './events-v2-rsvp-rsvp-v-2.universal.js';
export {
  SubdivisionTypeWithLiterals,
  RsvpStatusWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  RequestedFieldsWithLiterals,
  LocationTypeWithLiterals,
  StatusWithLiterals,
  EventStatusWithLiterals,
  EventTypeWithLiterals,
  RegistrationStatusWithLiterals,
  RsvpStatusOptionsWithLiterals,
  TaxTypeWithLiterals,
  CheckoutTypeWithLiterals,
  VisitorTypeWithLiterals,
  InputControlTypeWithLiterals,
  ValueTypeWithLiterals,
  ConferenceTypeWithLiterals,
  StateWithLiterals,
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  OriginWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  TypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateRsvpApplicationErrors,
  UpdateRsvpApplicationErrors,
  BulkUpdateRsvpsApplicationErrors,
  BulkDeleteRsvpsByFilterApplicationErrors,
  CheckInRsvpGuestsApplicationErrors,
  CancelRsvpGuestsCheckInApplicationErrors,
  ListCurrentRsvpsApplicationErrors,
  CommonSearchWithEntityContext,
  RsvpSearch,
  CommonQueryWithEntityContext,
  RsvpQuery,
} from './events-v2-rsvp-rsvp-v-2.universal.js';
